<template>
  <div class="exercise">
    <Header :title="title" :goBackHandler="goBack">
      <template slot="right-sum" v-if="!$route.query.type">
        <router-link :to="{path:'/exercise?type=exam/exercise/my&from=list'}">我的练习</router-link>
      </template>
    </Header>
    <van-dropdown-menu v-if="!ifMyExercises"
                       :active-color="$theme_color"
                       class="dropdown">
      <van-dropdown-item title="分类"
                         ref="classify">
        <div class="filter-box">
          <div class="tm-kind">
            <div class="tmk-item">
              <span :class="params.classify_id == item.id ? 'active':''"
                    v-for="(item,index) in attrclassify"
                    :key="index"
                    @click="selectId('classify',item.id)">{{item.title}}</span>
            </div>
          </div>
        </div>
      </van-dropdown-item>
      <van-dropdown-item title="类型"
                         ref="filter"
                         @closed="closed()">
        <div class="filter-box">
          <div class="tm-kind"
               v-for="(item,index) in attribute"
               :key="index">
            <div class="attr_title">{{item.attr}}</div>
            <div class="tmk-item">
              <span :class="item.attrValue == it.id ? 'active':''"
                    v-for="(it,i) in item.value"
                    :key="i"
                    @click="selectType('filter',index,it.id,'attr'+i)">{{it.name}}</span>
            </div>
          </div>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
    <Empty :empty_type="emptyType"
           class="emptyData"
           v-if="list.length == 0"></Empty>
    <List ref="list"
          :url="'/api/app/'+url"
          method="get"
          :params="params"
          :on-getdata="onGetdata"
          class="lists"
          :showText="list.length > 0">
      <ul class="news-content"
          :class="!ifMyExercises?'mt100':''"
          slot="item">
        <router-link tag="li"
                     v-for="(item, index) in list"
                     :key="index"
                     :to="{ name: 'ExerciseDetail', query: { id: item.id, type: $route.query.type} }">
          <div class="content">
            <div class="indexpic">
              <img :src="item.indexpic">
              <!-- <preview v-if="item.indexpic!==''"
                       :imgList="setImgArr(item)"></preview> -->
            </div>
            <div class="right_conten">
              <div class="name">
                <p>{{item.name}}</p>
                <span v-if="!ifMyExercises && item.related_course_id"
                      class="is_student_free">学员免费</span>
              </div>
              <div class="price"
                   v-if="!ifMyExercises">
                <span class="total_sales_num">{{$pub.setUnit(item.total_sales_num)}}人购买</span>
                <span class="is_free"
                      v-if="item.is_free">免费</span>
                <!-- <span class="no_free"
                      v-if="!item.is_free">￥{{item.price|toFixPrice}}</span> -->
                <span class="no_free"
                      v-if="!item.is_free">
                  <icon-price size="middle"
                              :priceType="item.type == 12 ? 2 : 1"></icon-price>
                  <span class="no_free">{{$pub.setUnit((item.price / 100))}}</span>
                </span>
              </div>
              <div class="goDetail"
                   v-if="ifMyExercises">
                去做题
              </div>
            </div>
          </div>
        </router-link>
      </ul>
    </List>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
import List from "@/components/List";
import preview from '@/components/que_answers/Preview';
export default {
  name: "Exercise",
  components: {
    Header,
    Empty,
    List,
    preview
  },
  data () {
    return {
      title: {
        name: "章节练习"
      },
      emptyType: {
        name: "暂无数据"
      },
      attr_val_id: {},
      option: [
        { text: "综合排序", value: 0 },
        { text: "最新", value: 1 },
        { text: "最热", value: 2 },
        { text: "价格从低到高", value: 3 },
        { text: "价格从高到低", value: 4 }
      ],
      attrclassify: [], // 资讯类别
      list: [], // 资讯列表
      classify_id: this.$store.state.personInfo.classify_id || localStorage.classify_id,
      params: {
        attr_val_id: this.$pub.objToStr(this.attr_val_id, ","),
      },
      showList: false, // 是否展示列表，在请求到分类之前不展示
      vipCourseCount: "",
      attribute: [],
      url: 'exercises',
      ifMyExercises: false
    };
  },
  created () {
    this.getData();
  },
  methods: {
    goBack () {
      // 由于我的练习和列表是一个页面，从列表进我的练习不调APP返回方法
      if (this.$store.state.app && !this.$route.query.from) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    // on event
    onTabChange (index) {
      console.log(index);
    },
    onGetdata (data) {
      this.list = data;
    },
    selectId (name, id) {
      this.params.classify_id = id;
      this.$refs.list.reset();
      this.$refs[name].toggle();
    },
    selectType (name, index, id, attr) {
      this.$set(this.attribute[index], 'attrValue', id);
      // this.$refs.list.reset();
      // this.$refs[name].toggle();
    },
    /**
     * 关闭弹框根据动态属性删选
     */
    closed () {
      let arr = [];
      let attr_val_id = '';
      this.attribute.forEach(item => {
        if (item.attrValue) {
          arr.push(item.attrValue)
        }
      })
      if (arr.length > 0) {
        attr_val_id = arr.join(',');
      }
      if (attr_val_id != this.params.attr_val_id) {
        this.params.attr_val_id = attr_val_id;
        this.$refs.list.reset();
      }
    },
    /**
     * 获取动态属性
     */
    getAttribute () {
      this.$http.get("/api/app/attribute/4").then(data => {
        let attr_val_id = {};
        data.forEach((item, index) => {
          this.$set(item, 'attrValue', 0);
          item.value.unshift({ id: 0, name: '全部' });
        });
        this.attribute = data;
      });
    },
    // 获取分类列表
    getClassify () {
      let param = { classify_id: this.classify_id };
      this.$pub.getClassify(param).then(res => {
        if (res.length > 0) {
          this.attrclassify = res;
          this.attrclassify.unshift({ id: this.classify_id, title: '全部' });
        }
      })
    },
    setImgArr (item) {
      let arrImg = [];
      arrImg.push(item.indexpic)
      return arrImg;
    },
    getData(){
      this.params.classify_id = this.classify_id;
      this.showList = true;
      this.getClassify();
      this.getAttribute();
      if (this.$route.query.type) {
        this.url = this.$route.query.type;
        this.ifMyExercises = true;
        this.title.name = '我的练习'
      } else{
        this.url = 'exercises';
        this.ifMyExercises = false;
        this.title.name = '章节练习'
      }
    }
  },
  watch:{
    $route(n,o){
      if(n.fullPath !== o.fullPath){ //监听路由参数是否变化
          this.getData()  //methods中封装的加载数据函数
          this.$refs.list.reset();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.exercise {
  font-family: PingFang SC;
  @extend %default-bg;
  background-color: #f6f6f6;
  .header a {
    color: #666666;
  }
  .filter-box {
    padding-top: 20px;
    padding-left: 30px;
  }
  .tm-kind {
    padding-bottom: 20px;
    border-bottom: 1px solid #f1f1f1;
    .attr_title {
      font-size: 28px;
      line-height: 50px;
    }
    p {
      padding: 32px 0 20px;
      font-size: 24px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
    }
    .tmk-item {
      span {
        margin: 0 46px 14px 0;
        display: inline-block;
        width: 200px;
        height: 72px;
        background: rgba(245, 245, 245, 1);
        border-radius: 6px;
        font-size: 26px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #646464;
        text-align: center;
        line-height: 72px;
        overflow: hidden;
        &:nth-child(3n + 0) {
          margin-right: 0;
        }
      }
      span.active {
        background: $theme_color;
        color: #ffffff;
      }
    }
  }
  .news-content {
    li {
      padding: 30px;
      background: #fff;
      border-bottom: 1px solid #f6f6f6;
      overflow: hidden;
      .content {
        .indexpic {
          width: 220px;
          height: 220px;
          float: left;
          img {
            width: 100%;
            height: 220px;
          }
        }
        .right_conten {
          color: #3d3a39;
          font-size: 30px;
          line-height: 33px;
          margin-left: 240px;
          font-weight: 500;
          .name {
            height: 160px;
            p {
              @include lines-eps(3);
            }
            .is_student_free {
              margin-top: 23px;
              color: $theme_color;
              font-size: 24px;
              display: inline-block;
              width: 120px;
              height: 42px;
              border-radius: 4px;
              text-align: center;
              line-height: 42px;
              border: 1px solid $theme_color;
            }
          }

          .price {
            font-weight: 500;
            overflow: hidden;
            margin-top: 30px;
            .total_sales_num {
              float: left;
              color: #999999;
              font-size: 24px;
            }
            .is_free,
            .no_free {
              float: right;
              font-size: 32px;
            }
            .is_free {
              color: #65ae58;
            }
            .no_free {
              color: #e62e2a;
            }
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .emptyData {
    margin-top: 100px;
  }
  .mt100 {
    margin-top: 100px;
  }
  .goDetail {
    float: right;
    width: 120px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 24px;
    background-color: $theme_color;
    color: #fff;
    border-radius: 4px;
  }
}
</style>
